import { Link } from "react-router-dom";
import { C } from "../constants/theme";
import { useSiteContent } from "../context/SiteContentContext";
import FadeIn from "../components/ui/FadeIn";
import TiltCard from "../components/ui/TiltCard";
import RainbowDivider from "../components/ui/RainbowDivider";

const Programs = () => {
  const { content } = useSiteContent();
  const p = content.programs || {};

  return (
  <div style={{ paddingTop: 72 }}>
    {/* ── Hero ── */}
    <section data-mmn="programs-hero" style={{ background:`linear-gradient(160deg,${C.mint} 0%,#2d9478 100%)`, padding:"100px 6vw 90px", position:"relative", overflow:"hidden", minHeight:"50vh", display:"flex", alignItems:"center" }}>
      <div style={{ position:"absolute", top:-80, right:-80, width:400, height:400, borderRadius:"50%", background:"rgba(255,255,255,0.06)", pointerEvents:"none" }}/>
      <div style={{ maxWidth:1100, margin:"0 auto", position:"relative", zIndex:2 }}>
        <div style={{ display:"inline-flex", alignItems:"center", gap:8, background:"rgba(255,255,255,0.15)", color:C.white, fontFamily:"Nunito", fontWeight:700, fontSize:11, letterSpacing:"0.15em", padding:"6px 16px", borderRadius:100, textTransform:"uppercase", marginBottom:20 }}>
          {p.heroBadge || "What We Offer"}
        </div>
        <h1 style={{ fontFamily:"Fredoka One", fontSize:"clamp(30px,5vw,60px)", color:C.white, lineHeight:1.1, margin:"0 0 20px", maxWidth:680 }}>
          {p.heroHeading || "Programs Designed for Whole Children."}
        </h1>
        <p style={{ fontFamily:"Lora", fontStyle:"italic", fontSize:"clamp(15px,2vw,19px)", color:"rgba(255,255,255,0.85)", maxWidth:600, lineHeight:1.8, margin:0 }}>
          {p.heroSub || "A micro school built around one belief: a child is not a grade."}
        </p>
      </div>
    </section>

    {/* ── Our Programmes ── */}
    <section style={{ background:C.cream, padding:"90px 6vw" }}>
      <div style={{ maxWidth:1100, margin:"0 auto" }}>
        <FadeIn>
          <div style={{ textAlign:"center", marginBottom:52 }}>
            <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12, color:C.mint, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:12 }}>Four Ways to Grow With Us</div>
            <h2 style={{ fontFamily:"Fredoka One", fontSize:"clamp(26px,4vw,44px)", color:C.navy, margin:"0 0 14px" }}>Our Programmes.</h2>
            <RainbowDivider />
          </div>
        </FadeIn>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(250px,1fr))", gap:24 }}>
          <FadeIn delay={0.06}>
            <TiltCard maxTilt={4} style={{ background:C.white, borderRadius:24, overflow:"hidden", border:`2px solid ${C.mint}22`, boxShadow:"0 4px 20px rgba(0,0,0,0.05)", height:"100%", display:"flex", flexDirection:"column" }}>
              <div style={{ background:C.mint, padding:"22px 24px" }}>
                <div style={{ fontFamily:"Nunito", fontWeight:800, fontSize:11, letterSpacing:"0.06em", textTransform:"uppercase", color:"rgba(255,255,255,0.85)", marginBottom:6 }}>Open Now · Since 2024</div>
                <div style={{ fontFamily:"Fredoka One", fontSize:22, color:C.white }}>Afterschool Socialisation Club</div>
              </div>
              <div style={{ padding:"22px 24px", flex:1, display:"flex", flexDirection:"column" }}>
                <p style={{ fontFamily:"Nunito", fontSize:13.5, color:C.text, lineHeight:1.75, marginBottom:14, flex:1 }}>Our onsite home base — a warm, faith-centred rhythm of learning, play, and community for children and the mothers who stay with them. <b>Ages 2.5 – 12.</b></p>
                <a href="#afterschool" style={{ fontFamily:"Nunito", fontWeight:700, fontSize:13, color:C.mint, textDecoration:"none" }}>See what it includes ↓</a>
              </div>
            </TiltCard>
          </FadeIn>
          <FadeIn delay={0.12}>
            <TiltCard maxTilt={4} style={{ background:C.white, borderRadius:24, overflow:"hidden", border:`2px solid ${C.coral}22`, boxShadow:"0 4px 20px rgba(0,0,0,0.05)", height:"100%", display:"flex", flexDirection:"column" }}>
              <div style={{ background:C.coral, padding:"22px 24px" }}>
                <div style={{ fontFamily:"Nunito", fontWeight:800, fontSize:11, letterSpacing:"0.06em", textTransform:"uppercase", color:"rgba(255,255,255,0.85)", marginBottom:6 }}>Opening January 2027</div>
                <div style={{ fontFamily:"Fredoka One", fontSize:22, color:C.white }}>Mini Muslims Nest Preschool</div>
              </div>
              <div style={{ padding:"22px 24px", flex:1, display:"flex", flexDirection:"column" }}>
                <p style={{ fontFamily:"Nunito", fontSize:13.5, color:C.text, lineHeight:1.75, marginBottom:14, flex:1 }}>Our dedicated early-years programme — the full curriculum, the five dimensions, onsite, online, or hybrid. <b>Ages 4 – 7.</b></p>
                <Link to="/programs/preschool" style={{ fontFamily:"Nunito", fontWeight:700, fontSize:13, color:C.coral, textDecoration:"none" }}>Explore the Preschool →</Link>
              </div>
            </TiltCard>
          </FadeIn>
          <FadeIn delay={0.18}>
            <TiltCard maxTilt={4} style={{ background:C.white, borderRadius:24, overflow:"hidden", border:`2px solid ${C.navy}22`, boxShadow:"0 4px 20px rgba(0,0,0,0.05)", height:"100%", display:"flex", flexDirection:"column" }}>
              <div style={{ background:C.navy, padding:"22px 24px" }}>
                <div style={{ fontFamily:"Nunito", fontWeight:800, fontSize:11, letterSpacing:"0.06em", textTransform:"uppercase", color:"rgba(255,255,255,0.85)", marginBottom:6 }}>A Dedicated Programme · Fully Online</div>
                <div style={{ fontFamily:"Fredoka One", fontSize:22, color:C.white }}>Quran for Kids</div>
              </div>
              <div style={{ padding:"22px 24px", flex:1, display:"flex", flexDirection:"column" }}>
                <p style={{ fontFamily:"Nunito", fontSize:13.5, color:C.text, lineHeight:1.75, marginBottom:14, flex:1 }}>Nine courses — Qaida to Tajweed, Seerah to Aqeeda — all delivered online, woven into one journey toward a child who owns their Muslim identity.</p>
                <Link to="/programs/quran-for-kids" style={{ fontFamily:"Nunito", fontWeight:700, fontSize:13, color:C.navy, textDecoration:"none" }}>Explore Quran for Kids →</Link>
              </div>
            </TiltCard>
          </FadeIn>
          <FadeIn delay={0.24}>
            <TiltCard maxTilt={4} style={{ background:C.white, borderRadius:24, overflow:"hidden", border:`2px solid #8B6BE822`, boxShadow:"0 4px 20px rgba(0,0,0,0.05)", height:"100%", display:"flex", flexDirection:"column" }}>
              <div style={{ background:"#8B6BE8", padding:"22px 24px" }}>
                <div style={{ fontFamily:"Nunito", fontWeight:800, fontSize:11, letterSpacing:"0.06em", textTransform:"uppercase", color:"rgba(255,255,255,0.85)", marginBottom:6 }}>Ongoing</div>
                <div style={{ fontFamily:"Fredoka One", fontSize:22, color:C.white }}>Homeschooling Support</div>
              </div>
              <div style={{ padding:"22px 24px", flex:1, display:"flex", flexDirection:"column" }}>
                <p style={{ fontFamily:"Nunito", fontSize:13.5, color:C.text, lineHeight:1.75, marginBottom:14, flex:1 }}>Your personalised weekly homeschool companion — after a one-time assessment, we plan your child's week so you just teach.</p>
                <Link to="/programs/homeschool-companion" style={{ fontFamily:"Nunito", fontWeight:700, fontSize:13, color:"#8B6BE8", textDecoration:"none" }}>Learn more →</Link>
              </div>
            </TiltCard>
          </FadeIn>
        </div>
      </div>
    </section>

    {/* ── Afterschool Club ── */}
    <section id="afterschool" data-mmn="programs-afterschool" style={{ background:`linear-gradient(135deg,${C.yellow}18,${C.coral}12)`, padding:"100px 6vw", borderTop:`4px solid ${C.yellow}40` }}>
      <div style={{ maxWidth:900, margin:"0 auto" }}>
        <FadeIn>
          <div style={{ textAlign:"center", marginBottom:52 }}>
            <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12, color:C.coral, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:12 }}>Open Now · Beyond School Hours</div>
            <h2 style={{ fontFamily:"Fredoka One", fontSize:"clamp(26px,4vw,46px)", color:C.navy, margin:"0 0 14px" }}>The Socialisation Club</h2>
            <RainbowDivider />
            <p style={{ fontFamily:"Nunito", fontSize:15, color:C.muted, maxWidth:560, margin:"0 auto", lineHeight:1.8 }}>
              Where homeschooling and school-going children, ages 2.5 to 12, come together for intentional, activity-based meetups — because good socialisation does not happen by accident.
            </p>
          </div>
        </FadeIn>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(240px,1fr))", gap:20 }}>
          {[
            { icon:"🏠", color:C.mint,  title:"Homeschooling Families", body:"Structured social experiences, group activities, and a community of like-minded parents all growing in the same direction." },
            { icon:"🌈", color:C.coral, title:"All Are Welcome",         body:"School-going children join too — every meetup is intentionally designed, with structured activities and Tarbiyah woven through, not just a playdate." },
            { icon:"💛", color:C.yellow,title:"Younger Kids + Mama",     body:"Mothers accompanying younger children join for free. The first socialisation a child needs is seeing their mother in community." },
          ].map(({ icon, title, color, body }) => (
            <FadeIn key={title} delay={0.08}>
              <TiltCard maxTilt={5} style={{ background:C.white, borderRadius:20, padding:"24px 20px", border:`2px solid ${color}28`, boxShadow:"0 4px 16px rgba(0,0,0,0.05)" }}>
                <div style={{ fontSize:28, marginBottom:12 }}>{icon}</div>
                <div style={{ fontFamily:"Fredoka One", fontSize:17, color, marginBottom:8 }}>{title}</div>
                <p style={{ fontFamily:"Nunito", fontSize:13.5, color:C.text, lineHeight:1.75, margin:0 }}>{body}</p>
              </TiltCard>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>

    {/* ── CTA ── */}
    <section style={{ background:C.cream, padding:"80px 6vw" }}>
      <div style={{ maxWidth:640, margin:"0 auto", textAlign:"center" }}>
        <FadeIn>
          <h2 style={{ fontFamily:"Fredoka One", fontSize:"clamp(24px,3.5vw,38px)", color:C.navy, margin:"0 0 14px" }}>Interested in Joining?</h2>
          <p style={{ fontFamily:"Nunito", fontSize:15, color:C.muted, lineHeight:1.75, marginBottom:32 }}>Book a visit and experience the environment for yourself.</p>
          <Link to="/admissions" style={{ background:C.navy, color:C.white, textDecoration:"none", fontFamily:"Nunito", fontWeight:800, fontSize:15, padding:"16px 40px", borderRadius:100, boxShadow:"0 6px 24px rgba(27,63,139,0.28)", display:"inline-block" }}>Start Enrolment</Link>
        </FadeIn>
      </div>
    </section>
  </div>
  );
};

export default Programs;
